import { Component, OnInit, AfterContentChecked, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { AlertMessageService } from '../../cfet-core';

@Component({
    selector: 'app-alert-warning',
    templateUrl: './alert-warning.component.html',
    styleUrls: ['./alert-warning.component.scss'],
    standalone: false
})
export class AlertWarningComponent implements OnInit, AfterContentChecked {
  showWarning: boolean;
  messages = [];
  @ViewChild('closeBtn') closeBtnElement: ElementRef;

  constructor(private alertMessageService: AlertMessageService,
    private renderer: Renderer2) { }

  ngOnInit () {
    this.alertMessageService.showWarning.subscribe((flag) => {
      if (flag !== null) {
        this.showWarning = flag;
      }
    });
    this.alertMessageService.warningMessages.subscribe((messages) => {
      this.messages = [];
      if (messages) {
        if (Array.isArray(messages)) {
          this.messages = messages;
        } else {
          this.messages.push(messages);
        }
      }
    });
  }

  ngAfterContentChecked () {
    if (this.closeBtnElement) {
      this.renderer.selectRootElement(this.closeBtnElement.nativeElement).focus();
    }
  }

  toggle (val) {
    this[val] = !this[val];
  }
}
